module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_int_02_6NV26_1SA_H2G.72988f40.jpg";